import { getSelectOptions } from '@/functions';
import { ISelectOption } from '@/interfaces';
import { TNomenclature } from '@/types';

type TParams = {
  getTitle?: (option: ISelectOption) => string;
  filter?: (option: ISelectOption) => boolean;
  emptyValueTitle?: string;
  addEmptyValue?: boolean;
};

const useNomenclatureData = (type: TNomenclature, params?: TParams) => {

  const selectOptions = getSelectOptions(type, params);

  const getTitle = (value: string | number) =>
    selectOptions.find(l => l.value === value)?.title as string;

  return ({
    selectOptions,
    getTitle
  });

};

export default useNomenclatureData;
